export function showToast(message) {
    const container = document.querySelector('#toast-container');
    if (!container) return;

    const toast = document.createElement('div');
    toast.className = 'cab-toast';
    toast.textContent = message;
    container.appendChild(toast);

    requestAnimationFrame(() => toast.classList.add('cab-toast--visible'));

    setTimeout(() => {
        toast.classList.remove('cab-toast--visible');
        setTimeout(() => toast.remove(), 300);
    }, 3500);
}
